<template>
  <div class="productDownBox">
    <!-- <div class="pic">
     <div  v-html="productItem.Content" class="picImg">  </div>
    </div> -->
    <p class="productDownTitle">
      <img src="../ProductMain/indexImg/titleAPc.png" alt="">
    </p>
    <!-- 返回标题 -->
    <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/productMain' }">产品下载中心</el-breadcrumb-item>
          <el-breadcrumb-item>当前页面</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <h1 class="productTitle">{{title}}</h1>
    <div class="productDown">
      <div class="productDownItem" v-for="item in productDown" :key="item.ID">
        <div class="productDownItemLeft">
          <p class="productDownItemLeftT" :title='item.Info'>{{item.Info}}</p>
          <p class="productDownItemLeftB">{{item.Edition}}</p>
        </div>
        <a class="productDownItemRight" :href='item.Path' >
         <img src="./img/down.png" alt="">
         <p>下载</p>
        </a>
      </div>
   </div>
  </div>
</template>

<script>
import { getProductShowDown } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      productItem: {},
      productDown: {}, // 下载
      title: ''
    }
  },
  watch: {
    '$route' () {
      // this.getProductShow({ id: this.$route.params.id })
      // this.getProductDown({ id: this.$route.params.id })
    }
  },
  created () {
    this.getProductShowDown({ id: this.$route.params.id })
    this.title = this.$route.params.name
    // console.log(this.$route.params, '1111')
  },
  mounted () {
  },
  methods: {

    // 产品下载
    async getProductShowDown (data) {
      const res = await getProductShowDown(data)
      if (res.Msg === '获取成功') {
        this.productDown = res.Data.reverse()
        this.productDown.forEach(item => {
          item.Path = request.defaults.baseURL + item.Path
        })
      }
      // console.log(res, '下载')
    }

  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.productDownBox{
  width: 100%;
  // 标题图片
  .productDownTitle{
    width: 100%;
    height: 460px*$sun;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .title{
    display: flex;
    justify-content: space-between;
    margin-top: 50px*$sun;
    width: 100%;
    color: #000;
    .breadcrumb{
        padding: 0 360px*$sun;
        font-size: 24px*$sun;
        font-weight: 500;
    }
  }

  .goBack:hover{
    color: #2380E1;
  }
  .productTitle{
    font-size: 36px*$sun;
    width: 1200px*$sun;
    font-weight: 500;
    margin: 40px*$sun auto;
  }
}
.pic{
  width: 1200px*$sun;
  margin: 0 auto;
  min-height: 600px*$sun;
  .picImg p{
    width: 100%;
  }
}
::v-deep .picImg img{
  width: 100%;
}
// 产品下在
.productDown{
  width: 1200px*$sun;
   min-height: 750px*$sun;
  margin: 0 auto;
  font-size: 20px*$sun;
  margin-bottom: 40px*$sun;
  .productDownTitle{
    font-size: 20px*$sun;
    border-top: 1px solid rgb(199, 200, 199);
    padding-top: 10px*$sun;
    padding-bottom: 10px*$sun;
  }
  .productDownItem{
    height: 144px*$sun;
    margin-top:20px*$sun;
    display: flex;
    justify-content: space-between;
    color: #333333;
    cursor: pointer;
    .productDownItemLeft{
    height: 144px*$sun;
      width: 1080px*$sun;
      background: #F9FAFC;
      // padding: 20px*$sun;
      // display: flex;
      // justify-content: space-between;
      // flex-direction: column;
      box-sizing: border-box;
    transition: all 0.2s;
    float: left;
      .productDownItemLeftT{
        font-size: 22px*$sun;
        height: 50px*$sun;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-weight: 500;
      }
      .productDownItemLeftB{
        font-size: 18px*$sun;
        font-weight: 500;
      }
    }
    .productDownItemRight{
    height: 144px*$sun;
      width: 100px*$sun;
      background: #F9FAFC;
      padding: 40px*$sun 33px*$sun;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      transition: all 0.2s;
      color:#333;
      float: right;
      img{
        width: 34px*$sun;
        height: 34px*$sun;
      }
      p{
        font-size: 16px*$sun;
        font-weight: 500;
      }
    }
  }
}
          .productDownItem:hover .productDownItemLeft{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }
           .productDownItem:hover .productDownItemRight{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }
</style>
